import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/athlete-proposition-bet.module.scss";
import {PROPOSITION_BETS} from "../../../widgets/proposition-bets-widget/proposition-bets-widgets.consts";
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {HorseshoeProgressBar} from "../../../core/components/round-progress-bar/horseshoe-progress-bar/horseshoe.progress-bar";
import {COLORS} from "../../../core/app/consts/colors";
import {AthletePropositionBetModuleProgressBarValue} from "./athlete-proposition-bet-module.progress-bar-value";

export const AthletePropositionBetModuleProgressBar = observer(({controller, row}) => {
  const {device, state} = controller;
  const {isScheduled} = state;
  const {isSmallView} = device;
  const {parameterProgress, paramName, isUnderOver} = row;
  const progressBarDuration: Number = PROPOSITION_BETS.PROGRESS_BAR.ANIMATION.duration * (parameterProgress / 100);

  const baseProps = {
    row,
    controller
  }

  const progressBarProps = {
    radius: isSmallView ? PROPOSITION_BETS.PROGRESS_BAR.SIZES.RADIUS.mobile : PROPOSITION_BETS.PROGRESS_BAR.SIZES.RADIUS.desktop,
    progress: parameterProgress,
    strokeWidth: PROPOSITION_BETS.PROGRESS_BAR.SIZES.stroke,
    strokeColor: useThemeColor(COLORS.accentPrimary),
    strokeBGColor: PROPOSITION_BETS.PROGRESS_BAR.strokeColor,
    hasInitialAnimation: true,
    animationDuration: progressBarDuration,
    animationDelay: PROPOSITION_BETS.PROGRESS_BAR.ANIMATION.delay
  }

  return (
    isUnderOver ? <div className={classNames(styles.parameter_container, {[styles.parameter_container_scheduled]: isScheduled})}>
        {
          !isScheduled ? <HorseshoeProgressBar {...progressBarProps}/> : null
        }
      <AthletePropositionBetModuleProgressBarValue {...baseProps}/>
      <div className={classNames(styles.parameter_name)}>{paramName}</div>
    </div> : null
  )
});
